import { Card } from '@/components/ui/card'

export function Section({
  title,
  hint,
  children,
}: {
  title: string
  hint?: string
  children: React.ReactNode
}) {
  return (
    <Card asChild className="p-4 md:p-5">
      <section>
        {/* Header reads as a distinct section label (accent bar + uppercase
            eyebrow + a hairline) so it never blends into prose or competes
            with the content's own headings. */}
        <div className="mb-4 flex items-stretch gap-2.5 border-b border-border pb-3">
          <span aria-hidden className="w-1 shrink-0 rounded-full bg-primary" />
          <div className="flex min-w-0 flex-col gap-0.5">
            <h2 className="text-xs font-semibold uppercase tracking-wider text-foreground">
              {title}
            </h2>
            {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
          </div>
        </div>
        {children}
      </section>
    </Card>
  )
}
